module.exports = __webpack_public_path__ + "static/media/topimg.c372955a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/topimg.jpg
// module id = 985
// module chunks = 2